class BouchilinoCustomerCare extends HTMLElement {
  connectedCallback() {
    if (this.controller) return;
    const form = this.querySelector('form');
    if (!form) return;
    this.form = form;
    this.controller = new AbortController();
    const options = { signal: this.controller.signal };
    this.addEventListener('change', event => {
      if (event.target.matches('[data-care-topic]')) this.syncOrder(true);
    }, options);
    form.addEventListener('submit', event => this.validate(event), { ...options, capture: true });
    form.addEventListener('input', event => {
      const key = event.target.dataset.careField;
      if (key === 'email' || key === 'body') this.error(key, '');
      const summary = this.querySelector('[data-care-error-summary]');
      if (summary) summary.hidden = true;
    }, options);
    this.syncOrder(false);
    form.noValidate = true;
    if (!this.feedbackFocused) {
      const feedback = this.querySelector('[data-care-feedback]');
      if (feedback) {
        this.feedbackFocused = true;
        requestAnimationFrame(() => { if (this.isConnected) feedback.focus(); });
      }
    }
    void this.populateProduct();
  }

  disconnectedCallback() {
    this.controller?.abort();
    this.controller = null;
    if (this.form) this.form.noValidate = false;
  }

  syncOrder(announce) {
    const wrapper = this.querySelector('[data-care-order]');
    const input = wrapper?.querySelector('input');
    const topic = this.querySelector('[data-care-topic]:checked');
    if (!wrapper || !input || !topic) return;
    const visible = topic.dataset.careTopic === 'order';
    wrapper.hidden = !visible;
    input.disabled = !visible;
    const notice = this.querySelector('[data-care-order-notice]');
    if (announce && notice) notice.textContent = visible ? this.dataset.orderShown : this.dataset.orderHidden;
  }

  error(key, message) {
    const field = this.querySelector('[data-care-field="' + key + '"]');
    const error = this.querySelector('[data-care-error="' + key + '"]');
    if (!field || !error) return;
    error.textContent = message;
    error.hidden = !message;
    if (message) field.setAttribute('aria-invalid', 'true');
    else field.removeAttribute('aria-invalid');
  }

  validate(event) {
    const email = this.querySelector('[data-care-field="email"]');
    const body = this.querySelector('[data-care-field="body"]');
    if (!email || !body) return;
    email.value = email.value.trim();
    const emailError = !email.value ? this.dataset.emailRequired : email.validity.typeMismatch ? this.dataset.emailInvalid : '';
    const bodyError = body.value.trim() ? '' : this.dataset.bodyRequired;
    this.error('email', emailError);
    this.error('body', bodyError);
    const summary = this.querySelector('[data-care-error-summary]');
    if (summary) {
      summary.textContent = emailError || bodyError ? this.dataset.errorSummary : '';
      summary.hidden = !(emailError || bodyError);
    }
    if (emailError || bodyError) {
      event.preventDefault();
      event.stopImmediatePropagation();
      (emailError ? email : body).focus();
    }
  }

  async populateProduct() {
    const handle = new URLSearchParams(location.search).get('product');
    const message = this.querySelector('[data-care-field="body"]');
    if (!message || message.value.trim() || !handle || !/^[a-z0-9-]+$/.test(handle)) return;
    const root = window.Shopify?.routes?.root || (this.lang === 'ar' ? '/' : '/en/');
    try {
      const response = await fetch(new URL(root + 'products/' + handle + '.js', location.origin), { signal: this.controller.signal });
      if (!response.ok) return;
      const product = await response.json();
      if (this.isConnected && !message.value.trim() && typeof product.title === 'string') {
        message.value = this.dataset.productPrefix + ': ' + product.title;
      }
    } catch (error) {
      if (error.name !== 'AbortError') return;
    }
  }
}
if (!customElements.get('bouchilino-customer-care')) customElements.define('bouchilino-customer-care', BouchilinoCustomerCare);
